export const inputtingPattern = /^[0-9-+#* ]*$/;
const pattern = /^(\+\d)?[0-9-#* ]+$/;

/**
 * Validate a telephone number.
 * @param target A telephone number to be validated
 * @returns `false` iff the telephone number is valid
 */
export const validateTelephoneNumber = (target: string): boolean => {
  const trimmed = target.trim();
  return trimmed.length !== 0 && trimmed.match(pattern) == null;
};
